import { z } from "zod";

export const PayrollItemMetaSchema = z.any();

export type PayrollItemMetaType = z.infer<typeof PayrollItemMetaSchema>;

export type PayrollItemType = {
  id: string;
  tenant_id: string;
  client_id: string;
  meta_data: PayrollItemMetaType;
  created_at: string;
  updated_at: string;
};

export const PAYROLL_ITEM_STATUSES = ["PENDING", "EXPORTED"] as const;

export const PAYROLL_ITEM_STATUS_OPTIONS = [
  { value: "PENDING", color: "pending" },
  { value: "EXPORTED", color: "complete" },
] as const;
